// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lx-calendar-tape-iframe[data-v-4d6e7625]{position:absolute;left:0;top:0;margin:7px 0 0 0;border:0;height:calc(100% - 7px)}", ""]);
// Exports
module.exports = exports;
